import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

interface EmergencyButtonProps {
  onClick: () => void;
}

export function EmergencyButton({ onClick }: EmergencyButtonProps) {
  const location = useLocation();
  const { t } = useTranslation();
  const isHome = location.pathname === '/';

  // Full "Call help" bar on home page
  if (isHome) {
    return (
      <button
        onClick={onClick}
        style={{
          position: 'fixed',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 'calc(100% - 48px)',
          maxWidth: '400px',
          minHeight: 'var(--touch-emergency)',
          backgroundColor: 'var(--caro-emergency)',
          color: 'white',
          fontSize: 'var(--font-body)',
          fontWeight: 700,
          border: 'none',
          borderRadius: '16px',
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(220, 38, 38, 0.4)',
          zIndex: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
        }}
        aria-label={t.emergency.callHelp || 'Call help'}
      >
        <span style={{ fontSize: 'var(--font-heading)' }}>{'\u{1F4DE}'}</span>
        {t.emergency.callHelp || 'Call help'}
      </button>
    );
  }

  // Compact circle icon on all other pages
  return (
    <button
      onClick={onClick}
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        backgroundColor: 'var(--caro-emergency)',
        color: 'white',
        fontSize: 'var(--font-heading)',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 4px 16px rgba(220, 38, 38, 0.4)',
        zIndex: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
      }}
      aria-label={t.emergency.callHelp || 'Call help'}
    >
      {'\u{1F4DE}'}
    </button>
  );
}
